// extracted by mini-css-extract-plugin
export default {"container":"UrlDisplay_container__alhlb","displayBytes":"UrlDisplay_displayBytes__EaVkB","openAppLink":"UrlDisplay_openAppLink__Br950"};